export const PaymentTypes: Record<PaymentType, PaymentTypeKey> = {
  STRIPE: 'Stripe',
  PAYPAL: 'Paypal',
  PIX: 'Pix',
  TICKET: 'Ticket',
};

export const PaymentTypesReversed: Record<PaymentTypeKey, PaymentType> = {
  Stripe: 'STRIPE',
  Paypal: 'PAYPAL',
  Pix: 'PIX',
  Ticket: 'TICKET',
};

export type PaymentType = 'STRIPE' | 'PAYPAL' | 'PIX' | 'TICKET';
export type PaymentTypeKey = 'Stripe' | 'Paypal' | 'Pix' | 'Ticket';
